export default {
  name: 'marking--orderSend',
  apiService: 'shoes',
  apiPath: '/admin/order/func/send',
  urlParamName: 'marking--orderSend',
};